import { render, staticRenderFns } from "./EmailModule.vue?vue&type=template&id=f9fdb96c&"
import script from "./EmailModule.vue?vue&type=script&lang=js&"
export * from "./EmailModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports